import React from 'react';
import { connect } from 'react-redux';
import TextField from '@mui/material/TextField';
import Icon from '@mui/material/Icon';
import ReportProblemIcon from '@mui/icons-material/ReportProblem';
import * as types from 'constants/actionTypes';
import LOOKUP from 'constants/lookup';
import { toMoney, toMoneyTyping } from 'library/moneyUtils';
import SecureComponent from '../SecureComponent';

class DecimalInputDiscount extends SecureComponent {
    constructor(props) {
        super(props);
        if (props.value) //if store has value relative to this component, initialize the state value
            this.state = { ...this.state, value: props.value, error: "" };
        else //in case the store does not have any value for this component, just clear it
            this.state = { ...this.state, value: "", error: "" };
    }

    componentWillReceiveProps(newProps) {
        if (newProps.value && newProps.value !== this.state.value)//if store's value relative to this component change, update the state value
            this.setState({ value: newProps.value });
        else if (!newProps.value)//in case the store does not have any value for this component, just clear it
            this.setState({ value: "" });

        if (newProps.error && newProps.error !== this.state.error)
            this.setState({ error: newProps.error });
    }

    onChange = (event) => {
        const value = event.target.value;
        const maskedStringValue = toMoneyTyping(value);
        const floatValue = parseFloat(maskedStringValue.replace(new RegExp(',', 'g'), ''));//.replace(',', ''));
        const min = parseFloat(this.props.min || 0);
        const max = parseFloat(this.props.max || 0);
        let finalFloatValue = floatValue;

        if (this.props.min !== undefined && floatValue <= min) {
            finalFloatValue = min
        }
        if (this.props.max !== undefined && floatValue >= max) {
            finalFloatValue = max;
        }

        const finalMaskedStringValue = toMoneyTyping(Math.round(finalFloatValue * 100 * 100) / 100);

        this.setState({ value: finalMaskedStringValue });
        this.updateStore(finalMaskedStringValue);
    }

    onBlur = (event) => {
        this.updateStore(event.target.value);
    }

    updateStore(value) {
        const error = this.validate(value);
        this.setState({ value, error });
        this.props.dispatch({ type: types.FORM_INPUT, value: value.replace(new RegExp(',', 'g'), ''), name: this.props.name });
        if (this.props.name == "productPOTotalPrice") {
            let unitPrice = parseFloat(value.replace(new RegExp(',', 'g'), '') / this.props.poproductQuantity).toFixed(2);
            this.props.dispatch({ type: types.FORM_INPUT, value: unitPrice, name: "productPOUnitPrice" });
        }

        if (this.props.name.includes("Amount")) {
            let discountPercentage = (value / this.props.originalPrice).toFixed(2) * 100;
            let newPrice = (this.props.originalPrice - value).toFixed(2);
            let productId = this.props.name.split('-')[1];
            this.props.dispatch({ type: types.FORM_INPUT, value: discountPercentage, name: "POSProductDiscountPercentage-" + productId });
            this.props.dispatch({ type: types.FORM_INPUT, value: newPrice, name: "POSProductDiscountNewPrice-" + productId });
        }

        if (this.props.name.includes("NewPrice")) {
            let discountAmount = (this.props.originalPrice - value).toFixed(2);
            let discountPercentage = Math.round(((this.props.originalPrice - value) / this.props.originalPrice) * 100);
            let productId = this.props.name.split('-')[1];
            this.props.dispatch({ type: types.FORM_INPUT, value: discountAmount, name: "POSProductDiscountAmount-" + productId });
            this.props.dispatch({ type: types.FORM_INPUT, value: discountPercentage, name: "POSProductDiscountPercentage-" + productId });
        }

    }

    validate(value) {
        const p = this.props;
        let error = null;
        if (!value && p.required)
            error = p.errorMsg ? p.errorMsg : p.name + ' is required';
        if (value && p.pattern) {
            let patt = new RegExp(p.pattern);
            if (!patt.test(value))
                error = p.patternErrorMsg ? p.patternErrorMsg : p.name + ' is invalid';
        }
        return error;
    }

    render() {
        const p = this.props;
        const value = this.state && this.state.value;
        const s = this.state;
        const showError = this.props.error && (value === '' || (!isNaN(value) && parseFloat(value) === 0));

        if (!s.authorized) return null;
        return (
            <div className={`${p.containerName || ``} form-group`}>
                <div className="POSProductDiscountListField">
                    <TextField
                        autoFocus={p.autoFocus}
                        name={p.name}
                        disabled={p.disabled}
                        underlineShow={p.underlineShow}
                        hintText={p.hintText}
                        errorText={showError ? p.error : ''}
                        type="number"
                        value={toMoney(s.value)}
                        inputStyle={p.inputStyle}
                        hintStyle={p.hintStyle}
                        floatingLabelStyle={p.floatingLabelStyle}
                        label={p.floatingLabelText || p.label}
                        ref={p.ref}
                        fullWidth={p.fullWidth || false}
                        className={p.className}
                        onChange={(e) => this.onChange(e)}
                        onBlur={(e) => this.onBlur(e)} 
                        InputLabelProps={{ shrink: true }}
                        variant="standard"
                    />
                    {this.props.costPrice && this.props.quantity &&
                        (
                            this.props.name.includes("NewPrice") && (this.props.value < this.props.costPrice * this.props.quantity) ?
                                <ReportProblemIcon className="danger"
                                    title={LOOKUP.pos.applyDiscountDialog.belowCostMessage} /> :
                                (this.props.name.includes("NewPrice") && (this.props.value < this.props.costPrice * this.props.quantity * 1.15) ?
                                    <ReportProblemIcon className="orange-text"
                                        title={LOOKUP.pos.applyDiscountDialog.belowMarginMessage} /> : null)
                        )
                    }
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state, props) => {
    return {
        value: state.form[props.name],
        error: state.form && state.form.error && state.form.error[props.name],
        userAutorizationLevel: state.common && state.common.user && state.common.user.authorizationLevel,
        poproductQuantity: state.form ? state.form["productPOQuantity"] ? state.form["productPOQuantity"] : 1 : 1
    };
};

export default connect(mapStateToProps)(DecimalInputDiscount);
